<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, sliceIndex) in data.body"
      :key="sliceIndex"
      :slice="slice"
      :primary="slice.primary"
      :items="slice.items"
    />
  </div>
</template>

<script>
import {
  Hero,
  HighlightSection,
  QuinconceSlice,
  ProcessArrow,
  SimpleCta,
} from '@@/shared-slices'

import {
  HighlightBlockSlice,
  BottomBanner,
  ContactSection,
} from '~/components/slices'

import { MediaCarrousel } from './components'

export default {
  components: {
    hero: Hero,
    highlight_section: HighlightSection,
    highlight_block: HighlightBlockSlice,
    quinconce_slice: QuinconceSlice,
    media_carrousel: MediaCarrousel,
    contact_section: ContactSection,
    bottom_banner: BottomBanner,
    process_arrow: ProcessArrow,
    simple_cta: SimpleCta,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>
